module.exports = __webpack_public_path__ + "img/icon-products-magento-64.830560db.svg";